import { Component, ContextType, PropsWithChildren } from 'react'

import { AppContext } from '../../contexts/AppContextProvider'
import { FallbackError } from './fallback-error'

interface InletErrorBoundaryState {
  hasError: boolean
}

export class InletErrorBoundary extends Component<PropsWithChildren<unknown>, InletErrorBoundaryState> {
  static contextType = AppContext
  context: ContextType<typeof AppContext>

  constructor(props: PropsWithChildren<unknown>) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error: unknown, errorInfo: unknown) {
    // eslint-disable-next-line no-console
    console.error(error, errorInfo)

    if (this?.context?.loggingOptions) {
      this.context.loggingOptions.client.log({ type: 'APP', data: error instanceof Error ? error.message : error })
    }

    if (this.context?.setError) {
      this?.context?.setError(true)
    }
  }

  render() {
    return this.context.error || this.state.hasError ? <FallbackError /> : this.props.children
  }
}
